import { Fragment } from 'react';

import { cn } from 'src/lib/utils';
import { DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';

type Props = {
  title: React.ReactNode;
  description?: React.ReactNode;
  icon?: React.ReactNode;
  children?: React.ReactNode;
  footer?: React.ReactNode;
};

export function InvitationDialogLayout({ title, description, icon, children, footer }: Props) {
  const centered = Boolean(icon);

  return (
    <Fragment>
      <DialogHeader className={cn('gap-1.5', centered ? 'items-center text-center' : 'pr-6')}>
        {icon && (
          <div className="mb-3 flex size-12 items-center justify-center rounded-lg border border-border bg-card shadow-sm [&_svg]:size-6">
            {icon}
          </div>
        )}
        <DialogTitle className="text-lg font-bold text-foreground">{title}</DialogTitle>
        {description && <DialogDescription>{description}</DialogDescription>}
      </DialogHeader>
      {children}
      {footer && <DialogFooter className={cn('pt-2', centered && 'sm:*:flex-1')}>{footer}</DialogFooter>}
    </Fragment>
  );
}
